import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgStatusIncomplete(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 2a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgStatusIncomplete)
